export default __webpack_public_path__ + "static/media/MetteFrederiksen.9bb79956.jpg";